/* eslint-disable no-use-before-define */
import React from 'react';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import TpSurveyItem from './TpSurveyItem';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import JsxHelper from '../Helpers/JsxHelper';
import LongText from '../Elements/LongText';

export default class ClientTpSurveyItem extends TpSurveyItem
{
  static FieldsToShowInDataTable ()
  {
    // prettier-ignore
    return [
      {
        label: 'Id',
        orderById: 'TpSurveyId',
        data: 'TpSurveyId',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 70,
      },
      {
        label: 'Name',
        orderById: 'ThirdPartySurveyName',
        data: (item) => (
          <LongText
            text={item.ThirdPartySurveyName}
            maxLength={50}
          />
        ),
        type: FieldTypesEnum.PureDataField,
      },
      // { label: "Bravo Client Id", orderById: "BravoClientId", data: "BravoClientId", type: FieldTypesEnum.PureDataField, minWidth: "110px", },
      { label: 'Source', orderById: 'ThirdPartySource', data: 'ThirdPartySource', type: FieldTypesEnum.PureDataField },
      {
        label: 'Third-Party Survey Id',
        orderById: 'ThirdPartySurveyId',
        data: 'ThirdPartySurveyId',
        type: FieldTypesEnum.PureDataField,
      },
      { label: 'Invoiceable?', orderById: 'IsUninvoiceable', data: (item) => JsxHelper.YesNoReverse(item.IsUninvoiceable) },
      { label: 'Is Activated', orderById: 'IsActivated', data: (item) => JsxHelper.YesNo(item.IsActivated) },
      { label: 'Modified On', orderById: 'ModifiedOnUtc', data: 'ModifiedOnUtc', type: FieldTypesEnum.PureDataField },
      //   { label: 'Modified By', orderById: 'ModifiedBy', data: 'ModifiedByUserName', type: FieldTypesEnum.PureDataField },
      {
        label: 'Actions',
        orderById: '',
        data: ClientTpSurveyItem.getActionsCellContent,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  static getActionsCellContent (item)
  {
    return (
      <DataTableActionMenu
        options={[
          {
            text: item.IsActivated == true ? 'Deactivate Survey' : 'Activate Survey',
            onClick: () => TpSurveyItem.activateDeactivateFunction(item),
            iconName: item.IsActivated ? 'fa-solid fa-xmark' : 'fa-solid fa-check',
            roleKey: 'project_edit',
          },
        ]}
      />
    );
  }
}
